// extracted by mini-css-extract-plugin
export default {"backdrop":"model_backdrop__iWw4H","modal":"model_modal__+9zto","slide-down":"model_slide-down__AuRnP"};